import { Toast } from "antd-mobile"
import { useEffect } from "react";

export default (loading: boolean | boolean[]) => {
  useEffect(() => {
    let isLoading;
    if (Array.isArray(loading)) {
      isLoading = loading.some(i => i)
    } else {
      isLoading = loading
    }
    isLoading ? Toast.loading('加载中', 0, undefined, false) : Toast.hide()
  }, [loading]);
}